<template>
  <div class="invitation-record-container">
    <div class="head">邀请记录</div>
    <div class="list">
      <div
        class="add"
        v-if="!taskid && !isSuccess"
        @click="$parent.bannerBtnClick()"
      >
        <div class="label">
          <img :src="require('@/assets/activityplace/邀请.png')" alt="" />
          <span>待邀请</span>
        </div>
        <div class="btn">领取{{ nextCutPrice || 0 }}元</div>
      </div>
      <div class="li" v-for="item in data" :key="item.id">
        <div class="label">
          <img :src="require('@/assets/setting/avatar.png')" alt="" />
          <div class="title">
            <span>{{ item.inviteeName }}</span>
            <span>邀请新用户，好物免费拿过瘾</span>
          </div>
        </div>
        <div class="desc">已帮{{ taskid ? '朋友' : '你' }}砍下{{ item.cutPrice }}元</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    nextCutPrice: {
      type: Number,
      default: null,
    },
    isSuccess: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      taskid: this.$route.query.taskid,
    }
  },
}
</script>

<style lang="less" scoped>
.invitation-record-container {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 22px;
  text-align: left;
  .head {
    font-size: 30px;
    font-weight: 600;
    color: #c2660f;
    line-height: 42px;
    padding: 16px 0 14px 20px;
  }
  .list {
    .add {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
      background-color: rgba(255, 255, 255, 0.3);
      img {
        display: inline-block;
        width: 80px;
        height: 80px;
      }
      span {
        font-size: 30px;
        font-weight: 600;
        color: #c2660f;
        line-height: 42px;
        margin-left: 8px;
      }
      .btn {
        background: #ffd768;
        border-radius: 6px;
        font-size: 24px;
        font-weight: 600;
        color: #c2660f;
        line-height: 34px;
        padding: 14px;
      }
    }
    .li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
      .label {
        display: flex;
        align-items: center;
      }
      img {
        display: inline-block;
        width: 80px;
        height: 80px;
      }
      .title {
        display: inline-block;
        margin-left: 8px;
        span {
          display: block;
        }
        span:nth-of-type(1) {
          font-size: 30px;
          font-weight: 600;
          color: #c2660f;
          line-height: 42px;
        }
        span:nth-of-type(2) {
          font-size: 20px;
          font-weight: 400;
          color: #c2660f;
          line-height: 28px;
          margin-top: 4px;
        }
      }
      .desc {
        font-size: 24px;
        font-weight: 600;
        color: #c2660f;
        line-height: 34px;
      }
    }
  }
}
</style>